import Layout from '@/layout';

export default {
  weight: 1,
  path: '/home',
  component: Layout,
  redirect: '/first',
  name: 'home',
  meta: { title: '主页', icon: 'el-icon-s-finance' },
  hidden: true,
  children: [
    {
      path: 'first',
      name: 'first',
      component: () => import('@/views/home/first'),
      meta: { title: '主页', icon: 'el-icon-s-data' },
      hidden: true,
    },
  ],
};
